import { MarketsSection } from '@/components/dashboard/MarketsSection'

export function MarketsPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <MarketsSection />
    </div>
  )
}
